import produce from 'immer';
import {
    HIDE_NAVIGATION,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    NAVIGATE_TO,
    SET_AGE_GROUP,
    SET_PARTICIPANTS,
    SET_ROOM,
    SHOW_NAVIGATION,
    SET_LEVEL,
    NAVIGATE_BY_HISTORY, NAVIGATE_TO_SCREEN,
} from '../action/actions';
import History from '../util/history';
import Api from "../util/api";

const initialState = {
    level: 1,
    page: 0,
    namedPage: null,
    room: {
        id: null,
        name: null,
        ageGroup: null,
        participants: null,
    },
    navigation: {
        show: false,
    },
};

const appReducer = (state = initialState, action) => {
    return produce(state, draft => {
        const {payload, type} = action;

        switch (type) {
            case SHOW_NAVIGATION:
                draft.navigation.show = true;
                break;

            case HIDE_NAVIGATION:
                draft.navigation.show = false;
                break;

            case NAVIGATE_NEXT:
                History.push(state.page + 1);
                draft.namedPage = null;
                draft.page = state.page + 1;
                if (state.room.name) {
                    Api.setScreen(state.room.name, draft.page).then();
                }
                break;

            case NAVIGATE_PREVIOUS:
                History.push(state.page + 1);
                draft.namedPage = null;
                draft.page = state.page - 1;
                break;

            case NAVIGATE_TO:
                History.push(payload.page);
                draft.namedPage = (state.namedPage === payload.page) ? null : payload.page;
                break;

            case NAVIGATE_TO_SCREEN:
                const {screen} = payload;

                History.push(screen);
                draft.namedPage = null;
                draft.page = Number(screen);
                break;

            case NAVIGATE_BY_HISTORY:
                if (isNaN(payload.page)) {
                    draft.namedPage = (state.namedPage === payload.page) ? null : payload.page;
                } else {
                    draft.namedPage = null;
                    draft.page = payload.page;
                }
                break;

            case SET_AGE_GROUP:
                draft.room.ageGroup = action.payload.ageGroup;
                break;

            case SET_PARTICIPANTS:
                draft.room.participants = action.payload.participants;
                break;

            case SET_ROOM:
                draft.room = payload;
                break;

            case SET_LEVEL:
                draft.level = payload.level;
                break;

            // no default
        }
    });
};


export default appReducer;
